import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

import LoadingIcon from '../../components/LoadingIcon';

function mapStateToProps(state) {
   return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

class Home extends Component {

  render() {
    return (
      <div className="Home">
        <div className="column-center column-m">
          <div className="coming_soon">
            <img className="coming_soon__hero" src="https://blacksquare.nyc3.digitaloceanspaces.com/paigelocke/paige_locke_kitchen_design_hero_1000.jpg" />
            <h2>Welcome to Paige Marie Locke Kitchen Design</h2>
            <p>This site is currently under construction. Please check back soon for updates or send us a message to get in touch.</p>
          </div>
          <Link to="/contact">
            <button className="btn btn--outline btn--100">Send a message</button>
          </Link>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/views/Home/Home.js